import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

//window.$SERVER_API = 'http://localhost/boletasaatrac/php/';
window.$SERVER_API = 'https://boletasaatrac.org.ar/php/';

//window.$SERVER_API_DEV = "https://serviciosmc.com.ar/pmc/";
//window.$SERVER_API_DEV = 'http://localhost/boletasaatrac/php/';
window.$SERVER_API_DEV = "https://boletasaatrac.org.ar/php/";
window.$MAX_REMUN = 9999999.99;

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

